module.exports = "<div class=\"q-col-3 q-no-pad q-text-right-til-md page-navigation\"> <div class=nav-btn-wrap> <a href=# class=\"nav-btn js-prev-page\" data-previous-page=\"{%- prevPage %}\"><i class=\"fa fa-angle-left q-icon-marg-right\"></i> Previous</a> <a href=# class=\"nav-btn js-next-page\" data-previous-page=\"{%- nextPage %}\">Next <i class=\"fa fa-angle-right q-icon-marg-left\"></i></a> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/pageNavigation.html
// module id = 1159
// module chunks = 1